import { DateTime } from "luxon";
import { AssistantMessage } from "./assistant-message.model";

export class AssistantConversation {
    constructor(
        public readonly id: number,
        public readonly title: string,
        public readonly screenContext: Record<string, unknown> | null,
        public readonly createdAt: DateTime,
        public readonly updatedAt: DateTime,
        public readonly lastMessagePreview: string,
        public readonly messages: AssistantMessage[] = [],
    ) {}
}
